import WarningRoundedIcon from "@mui/icons-material/WarningRounded"
import {
    Alert,
    AlertColor,
    AlertPropsVariantOverrides,
    SxProps,
    Theme,
    useTheme,
} from "@mui/material"
import { OverridableStringUnion } from "@mui/types"

interface Props {
    alertMessage: string
    severity: AlertColor
    variant?: OverridableStringUnion<"standard" | "filled" | "outlined", AlertPropsVariantOverrides>
    alertMessageBold?: string
    sx?: SxProps<Theme>
}
const AlertComponent = ({ severity, variant, alertMessage, alertMessageBold, sx }: Props) => {
    const theme = useTheme()
    return (
        <Alert
            icon={<WarningRoundedIcon />}
            severity={severity}
            variant={variant ?? "filled"}
            sx={{ color: theme.palette.common.white, width: "100%", ...sx }} //add custom sx
        >
            <b>{alertMessageBold}</b>
            {alertMessage}
        </Alert>
    )
}

export default AlertComponent
